export * from './authenticator';

export const acquireTokenTimeoutInMilliseconds = 15000;
